import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconRefreshCw = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--refresh-cw")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M22 14a1 1 0 0 1 .927.625l.005.013a1 1 0 0 1 .068.364V21a1 1 0 0 1-2 0v-3.688l-2.933 2.755a10 10 0 0 1-16.5-3.733 1 1 0 1 1 1.886-.668A8 8 0 0 0 9.229 20.8a8.015 8.015 0 0 0 7.446-2.169l2.8-2.631H16a1 1 0 0 1 0-2h6zM14.212 1.247a10 10 0 0 1 7.22 6.417 1 1 0 1 1-1.885.667 8 8 0 0 0-5.776-5.134 8.015 8.015 0 0 0-7.446 2.17l-2.8 2.63H7a1 1 0 1 1 0 2H1a1 1 0 0 1-.927-.625L.068 9.36A1 1 0 0 1 0 8.996V2.998a1 1 0 0 1 2 0v3.688l2.933-2.755a10 10 0 0 1 9.28-2.684z" id="icon--centivo--refresh-cw"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" transform="matrix(-1 0 0 1 23 0)" xlinkHref="#icon--centivo--refresh-cw"/>
      </g>
  </IconWrapper>
)
